import { ComponentProps, FC } from 'react';
import { CompanyList } from '../components/pages/company-list/company-list';
import { CompanyRoot } from '../components/pages/company-root/company-root';
import { KoumutenList } from '../components/pages/koumuten-list/koumuten-list';
import { ModelImageRoot } from '../components/pages/model-image-root/model-image-root';
import { ModelRoot } from '../components/pages/model-root/model-root';
import { ProjectImageRoot } from '../components/pages/project-image-root/project-image-root';
import { ProjectRoot } from '../components/pages/project-root/project-root';
import { UserList } from '../components/pages/user-list/user-list';
import { CsvList } from '../components/pages/csv-list/csv-list';
import { routes } from './routes';

export const privateRoutes: [string, FC<ComponentProps<any>>][] = [
  [routes.userList, UserList],
  [routes.csvList,CsvList],
  [routes.koumutenList, KoumutenList],
  [routes.companyListPlaceHolder, CompanyList],
  [routes.projectListPlaceholder, CompanyRoot],
  [routes.projectRootPlaceholder, ProjectRoot],
  [routes.projectImageListPlaceholder, ProjectRoot],
  [routes.projectImageRootPlaceholder, ProjectImageRoot],
  [routes.modelListPlaceholder, CompanyRoot],
  [routes.modelRootPlaceholder, ModelRoot],
  [routes.labelListOfModelPlaceholder, ModelRoot],
  [routes.modelImageListPlaceholder, ModelRoot],
  [routes.modelImageRootPlaceholder, ModelImageRoot]
];
